import { observer } from 'mobx-react';
import * as React from 'react';
import { Button, Card, CardContent, CardFooter, EqualHeight, Heading, Text } from 'telia-front-react';
import config from '../../../Config';
import { Address, Room } from '../../../stores/AddressStore';
import { TranslationsContext } from '@teliaee/telia-translate';

interface ExceptionCardProps {
  selectedAddress: Address;
  selectedRoom?: Room;
}

function ExceptionCard(props: ExceptionCardProps): JSX.Element {
  const translate = React.useContext(TranslationsContext).translate;

  const resolveUrl = () => {
    return (
      `${config.teliaWebSelfServiceUrl}/teenused/internet/asukoht?productOfferingCode=` +
      `&addressData=${props.selectedAddress.id}|${props.selectedAddress.buildingId}` +
      `|${props.selectedRoom && props.selectedRoom.roomId ? props.selectedRoom.roomId : ''}` +
      `|${props.selectedRoom && props.selectedRoom.roomName ? props.selectedRoom.roomName : ''}`
    );
  };

  return (
    <Card padding="medium" type="employee" background="neutral-bg-level-1" className="text-left" elevation={1}>
      <CardContent>
        <Text>
          <EqualHeight group="internet-speed">
            <Heading element="h2">{translate('internetAndTvCalculator.exceptionCard.title')}</Heading>
          </EqualHeight>
          <EqualHeight group="card-text">
            <p>{translate('internetAndTvCalculator.exceptionCard.description')}</p>
          </EqualHeight>
        </Text>
      </CardContent>
      <CardFooter>
        <Text>
          <EqualHeight group="price">
            <strong className="h5 text-bold">
              <Button url={resolveUrl()} target="_blank" text={translate('internetAndTvCalculator.exceptionCard.order')} />
            </strong>
          </EqualHeight>
        </Text>
      </CardFooter>
    </Card>
  );
}

export default observer(ExceptionCard);
